module.exports = __webpack_public_path__ + "static/media/car2.441d4299.png";